// extracted by mini-css-extract-plugin
export var pillWrapper = "_qd-0";
export var showOverflow = "_qd-1";